import type { ContentFilterOptions } from "../interfaces"

type ContentFilterGroup = keyof ContentFilterOptions
type ContentFilterOption = ContentFilterOptions[ContentFilterGroup][number]

const GROUP_LABELS: Record<ContentFilterGroup, string> = {
  campaigns: "Кампания",
  orders: "Ордер",
  agents: "Агент",
}

export function resolveContentFilterOptions(
  group: ContentFilterGroup,
  options: readonly ContentFilterOption[],
  selectedIds: readonly number[] | undefined,
): { options: ContentFilterOption[]; value: ContentFilterOption[] } {
  const byId = new Map<number, ContentFilterOption>()
  const fallback = (id: number) => `${GROUP_LABELS[group]} #${id}`
  for (const option of options) {
    if (byId.has(option.id)) continue
    byId.set(option.id, {
      ...option,
      name: option.name.trim() ? option.name : fallback(option.id),
    })
  }
  const value: ContentFilterOption[] = []
  for (const id of new Set(selectedIds)) {
    let option = byId.get(id)
    if (!option) {
      option = { id, name: fallback(id) }
      byId.set(id, option)
    }
    value.push(option)
  }
  return { options: [...byId.values()], value }
}
